/* unplugin-vue-components disabled */import script from "./WOCapabilityManager.vue?vue&type=script&setup=true&lang=js"
export * from "./WOCapabilityManager.vue?vue&type=script&setup=true&lang=js"

import "./WOCapabilityManager.vue?vue&type=style&index=0&id=bc18a268&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc18a268"]])

export default __exports__